// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation SendPhoneVerificationMutation($input: SendPhoneVerificationInput!) {
    sendPhoneVerification(input: $input) {
      success
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
